import { PENDING_TO_RETURN, PENDING_TO_RETURN_SUCCESSFUL, PENDING_TO_RETURN_FAILED } from './actionTypes';

export const pentingToReturnTask = (task,token, history) => {

    return {
        type: PENDING_TO_RETURN,
        payload: { task,token, history }
    }
}

export const pentingToReturnTaskSuccessful = (msg) => {
    return {
        type: PENDING_TO_RETURN_SUCCESSFUL,
        payload: msg
    }
}

export const pentingToReturnTaskFailed = (msg) => {
    return {
        type: PENDING_TO_RETURN_FAILED,
        payload: msg
    }
}
